import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom';
import {SelectPatientSample,SelectAllPatients} from '../OfflineDb/IndexDbTranscSP'
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import StarRatings from 'react-star-ratings';


const mapStateToProps = (store)=>{
    return store
}
  
const mapDispatchToProps = (dispatch)=>{
    return{
      ShowAlert : (Settings)=> {dispatch({type:"UpdateAlert",payload:Settings})},
      ShowLoader:(Isloading)=> {dispatch({type:"UpdateLoader",payload:Isloading})},
    }
}

class PatientSamples_Dispatch extends Component {

constructor(props) {
    super(props);
    this.state = {

        Data:[],

        Patientslist:[],
        Riderslist:[],
        HCFlist:[],

    };
}

render(){

    const CellMenu=(cell, row) => {
        return (
            <div>
                <button onClick={()=>{this.RemovePatientSampleFromList(row.id)}} data-toggle="tooltip" title="Enter Status" class="btn TableRow_btn"><i class="fa fa-trash" aria-hidden="true"></i></button>
            </div>
        )   
    }

    const Columns = [
        {
            dataField: 'id',
            text: 'Sample Id',
        },
        {
            dataField: 'PatientName',
            text: 'Patient Name',
        },
        {
            dataField: 'PatientContact',
            text: 'Patient Contact',
        },{
            dataField: '',
            text: '',
            headerStyle: (colum, colIndex) => {return { width: '120px' }},
            formatter:(cell, row)=>{ return CellMenu(cell, row)},
            csvExport:false
        }
    ];

return(

<div>
    <MainLayout/>
    <div id="right-panel" class="right-panel">
        <Topmenu PageTitle="Patient Samples" isShowAddBtn={false} />              

        <div class="content">

            <div class="card" style={{marginBottom:"20px",background:"none",boxShadow:"none"}}>
                <div class="card-body row" style={{padding:"0px"}}>               
                    <div class="widget-tabs-list">
                        <ul class="Cases-nav nav nav-tabs">
                            <li><Link data-toggle="tab" to="/Patient_Samples">All Samples</Link></li>
                            <li><Link data-toggle="tab" to="/PatientSamples_Dispatch" class="active show">Dispatch Samples</Link></li>
                        </ul>
                    </div>             
                </div>
            </div> 

            <div class="card">
                <div class="card-body">

                    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12" style={{marginBottom:"40px"}}>
                        <input autocomplete="off" type="text" class="form-control Search_InputField" id="SampleToDispatch_Id" placeholder="Start typing or scanning..."/>
                    </div>
                        
                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <Table 
                            keyField="id" 
                            data={ this.state.Data } 
                            isPagination={false}
                            columns = {Columns}
                            loading={false}
                        />
                    </div>
                                        
                    <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop:"30px"}}>
                        <button type="button" onClick={this.DispatchSamples} id="Form_SaveBtn" class="btn btn_style1">Save</button>
                    </div>

                </div>
            </div>
                        

        </div>
    
    </div>
</div>

)}


componentWillMount()
{
    if(this.props.UserAuthentication.AuthToken==="")
    {
        this.props.history.push("/Login")
    }
}
componentDidMount(){

    Common.AddClassToMenueLink("MenuLink_PatientSamples")

    $("#SampleToDispatch_Id").keyup((event)=> {
        if (event.keyCode === 13) {
            this.ValidateSample()
        }
    });

    this.GetPageConfigData(()=>{})
}
GetPageConfigData=(CallBack)=>{
    this.props.ShowLoader({Isloading:true})
    var d1= $.Deferred();
    this.SelectPatients(()=>{d1.resolve()})
    $.when(d1).done( ()=> {
        this.props.ShowLoader({Isloading:false})
        CallBack()
    });
}
SelectPatients=(Callback)=>{
    SelectAllPatients((data)=>{
        var ProcessedPatient= Common.ProcessDataInArray(data,"id")
        this.setState({
            Patientslist:ProcessedPatient
        })
        Callback()
    },(error)=>{
        this.props.ShowAlert({Type:0,Msg:error})
        setTimeout(function(){$("#Alertmsgbtn").click()}, 50);
        Callback()
    })
}
ValidateSample=()=>{
    if($("#SampleToDispatch_Id").val()=="")
    {
        this.props.ShowAlert({Type:0,Msg:"No record found"})
        setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
        return
    }
    SelectPatientSample(Common.TryParseInt($("#SampleToDispatch_Id").val()),(resp)=>{
        if(resp==undefined || resp.hfcId !=this.props.UserAuthentication.UserInfo.hcfId || resp.isSubmitted==false || resp.deliveryStatus!=Common.DeliveryStatus.Pending )
        {
            $("#SampleToDispatch_Id").val("")
            this.props.ShowAlert({Type:0,Msg:resp==undefined|| resp.hfcId !=this.props.UserAuthentication.UserInfo.hcfId || resp.isSubmitted==false ?"No record found": "Sample alredy dispatched"})
            setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
            return
        }
        this.LoadPatientSampleInList(resp)
    },()=>{})
}
LoadPatientSampleInList=(data)=>{
    let Arr= this.state.Data
    for(var i in Arr)
    {
        if(Arr[i].id==data.id)
        {
            $("#SampleToDispatch_Id").val("")
            return
        }
    }
    data.PatientName = data.patientId==null||data.patientId==""?"": this.state.Patientslist[data.patientId].name
    data.PatientContact = data.patientId==null||data.patientId==""?"": this.state.Patientslist[data.patientId].contact
    Arr.unshift(data)
    this.setState({
        Data: Arr
    })
    $("#SampleToDispatch_Id").val("")
}
RemovePatientSampleFromList=(id)=>{
    var Array = this.state.Data.filter(function (item, index) {
        return item.id != id;       
    });
    this.setState({                
        Data :Array,
    })
}


DispatchSamples=()=>{

    if(this.state.Data.length==0)
    {
        this.props.ShowAlert({Type:0,Msg:"Please add atleast one sample to save"})
        setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
        return
    }
    let SampleIds= Common.convertToCommaString(this.state.Data,"id")
    this.props.ShowLoader({Isloading:true})
    var Parameters={
        SampleIds: SampleIds,
        dispatchDatetime:null,
    }
    Common.Ajax(this.props.UserAuthentication.AuthToken,"Get",false,Common.APILinks.Dispatch_PatientSample,Parameters,(resp)=>{  
        if(resp.status==true)
        {
            SyncConfig(()=>{
                this.setState({Data:[]})
                this.props.ShowLoader({Isloading:false})
                this.props.ShowAlert({Type:1,Msg: "Saved successfully" })
                setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
            },
            ()=>{
                this.setState({Data:[]})
                this.props.ShowLoader({Isloading:false})
                this.props.ShowAlert({Type:0,Msg:"Error in sync, please reload the page"})
                setTimeout(function(){$("#Alertmsgbtn").click()}, 50);
            })
        }
        else
        {
            this.props.ShowLoader({Isloading:false})
            this.props.ShowAlert({Type:0,Msg:resp.message })
            setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
        }
    },
    (error)=>{
        this.props.ShowLoader({Isloading:false})
        this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
    })

}

}

export default connect( mapStateToProps , mapDispatchToProps )(PatientSamples_Dispatch);
